import React, { useState, useContext, useRef, useEffect } from 'react';
import { Box, TextField, Button, Typography, Paper, InputAdornment, IconButton } from '@mui/material';
import { AuthContext } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

const LoginPage = () => {
  const { login } = useContext(AuthContext);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  // AbortController ref
  const loginAbortControllerRef = useRef();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    const trimmedUsername = username.trim();

    // set up AbortController for this request
    const controller = new AbortController();
    loginAbortControllerRef.current = controller;

    try {
      const res = await api.post(
        '/api/auth/login',
        { username: trimmedUsername, password },
        { signal: controller.signal }
      );
      login(res.data.accessToken, res.data.role, trimmedUsername, res.data.userId);
      navigate('/');
    } catch (err) {
      if (err.name !== 'CanceledError') {
        console.error(err);
        setError('Invalid credentials');
      }
    }
  };

  // abort any in-flight login on unmount
  useEffect(() => {
    return () => {
      loginAbortControllerRef.current?.abort();
    };
  }, []);

  return (
    <Box sx={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh', 
      backgroundColor: '#ecf0f1' 
    }}>
      <Paper sx={{ p: 4, width: 300 }}>
        <Typography 
          variant="h4" 
          align="center" 
          gutterBottom={false} 
          sx={{ mb: 0, fontFamily: 'Montserrat, sans-serif' }}
        >
          w-meter
        </Typography>
        <form onSubmit={handleSubmit}>
          <TextField
            label="Username"
            fullWidth
            margin="normal"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            inputProps={{ autoCapitalize: 'none', autoCorrect: 'off' }}
          />
          <TextField
            label="Password"
            type={showPassword ? 'text' : 'password'}
            fullWidth
            margin="normal"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            inputProps={{ autoCapitalize: 'none' }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => setShowPassword(!showPassword)}
                    edge="end"
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              )
            }}
          />
          {error && <Typography color="error">{error}</Typography>}
          <Button type="submit" variant="contained" fullWidth sx={{ mt: 2 }}>
            Login
          </Button>
        </form>
      </Paper>
    </Box>
  );
};

export default LoginPage;
